import React, { FC, useMemo, useState } from 'react';
import { Result } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { workOrdersRestCrudThunksForSupplier } from '../../thunks/work_orders_thunks';
import SupplierWorkOrderEditForm from '../supplier_work_order_edit_form/SupplierWorkOrderEditForm';
import { EditPage } from '../edit_page/EditPage';
import { goBackLink, recursiveRemovePreserve } from '../../utils/HistoryUtils';
import {
	getEntityById,
	hasSupplierWriteAccessToWorkOrder,
	nullSafeGet,
} from '../../utils/DataAccessUtils';
import ContractorWorkOrderEditForm from '../supplier_work_order_edit_form/ContractorWorkOrderEditForm';
import { getWorkOrderSelector } from '../../selectors/workOrderSelectors';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import BackButton from '../back_button/BackButton';
import useMountEffect from '../../hooks/useMountEffect';

require('./EditSupplierWorkOrderPage.less');
const queryString = require('qs');

const EditSupplierWorkOrderPage: FC<any> = ({
	match,
	getWorkOrder,
	history,
	workOrder,
	currentUser,
	location,
}): React.ReactElement => {
	const [fetching, setFetching] = useState(true);
	const workOrderId = match.params.id;

	useMountEffect(() => {
		getWorkOrder(workOrderId).then(() => {
			setFetching(false);
		});
	});

	const defaultUrlPath = `/supplier/workOrders/detail/${workOrderId}/details`;

	const EditForm = useMemo(
		() =>
			nullSafeGet('locationId', workOrder) === -100
				? ContractorWorkOrderEditForm
				: SupplierWorkOrderEditForm,
		[workOrder]
	);

	// The list links here from search records, which cannot tell a read-only facility from a
	// writable one. The full work order can, and the backend refuses the save without write access.
	return fetching ? (
		<PageLoadingPlaceholder />
	) : !hasSupplierWriteAccessToWorkOrder(currentUser, workOrder) ? (
		<Result
			status="403"
			title="You can't edit this work order"
			subTitle="Your facility has view-only access to it."
			extra={<BackButton type="primary" buttonText="Go Back" />}
		/>
	) : (
		<EditPage
			title="Edit Work Order"
			formComponentProps={{
				formData: workOrder,
				onSuccess: (rec) => {
					let string = goBackLink(location, defaultUrlPath);
					const [path, queryParams] = string.split('?');
					let urlSearchParams = queryString.parse(queryParams);
					history.push(`${path}?${recursiveRemovePreserve(urlSearchParams)}`);
				},
			}}
			fetching={fetching}
			FormComponent={EditForm}
		/>
	);
};

const mapStateToProps = (state, ownProps) => {
	return {
		workOrder: getEntityById(ownProps.match.params.id, state.work_orders),
		currentUser: state.session.currentUser,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getWorkOrder: (id) => dispatch(workOrdersRestCrudThunksForSupplier.readOne(id)),
});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(EditSupplierWorkOrderPage)
);
